/* assets/before-after-slider.js */

class BeforeAfterSlider extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('.ba-range-input');
    this.afterImage = this.querySelector('.ba-img-after');
    this.handle = this.querySelector('.ba-handle');

    if (this.input && this.afterImage && this.handle) {
      this.input.addEventListener('input', this.update.bind(this));
    }
  }

  update(e) {
    const value = e.target.value;
    
    // REVEAL LOGIC:
    // Clip the right side of the "After" image based on slider position.
    // If value is 50%, we clip 50% from the right.
    // If value is 10%, we clip 90% from the right.
    const clipAmount = 100 - value;
    this.afterImage.style.clipPath = `inset(0 ${clipAmount}% 0 0)`;
    
    // Move the handle line
    this.handle.style.left = `${value}%`;
  }
}

if (!customElements.get('before-after-slider')) {
  customElements.define('before-after-slider', BeforeAfterSlider);
}